import React from 'react';
import { useParams } from 'react-router-dom';
import { destinationsContent } from '../../content/destinations/DestinationsContent';
import Article from './Article';
import Breadcrumbs from '../Breadcrumbs';
import { generateDestinationBreadcrumbs } from '../../utils/breadcrumbHelpers';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { destinationCardData } from '../../content/destinations/DestinationCardData';
import { articlesCardData } from '../../content/articles/ArticlesCardData';

const BreadcrumbsContainer = styled(Container)`
  padding-top: 20px;
`;

const DestinationNavigationWrapper = () => {
  const { country, destination } = useParams();
  const content = destinationsContent[destination || ''];
  const cardData =
    destinationCardData[country as keyof typeof destinationCardData];
  const destinationData = cardData.find((item) => item.slug === destination);
  const {
    title,
    imageUrl,
    klookUrl,
    getYourGuideUrl,
    titleNameOverride,
    relatedArticlesSlugs = [],
  } = destinationData ?? {};
  const relatedDestinations = cardData.filter((item) =>
    relatedArticlesSlugs.includes(item.slug)
  );

  const articleCardData =
    articlesCardData[country as keyof typeof articlesCardData];
  const relatedArticles = articleCardData.filter((item) =>
    relatedArticlesSlugs.includes(item.slug)
  );

  // Generate breadcrumbs only if both country and content exist
  const breadcrumbItems =
    country && title && destination
      ? generateDestinationBreadcrumbs(country, title, destination)
      : [];

  return (
    <>
      <BreadcrumbsContainer>
        <Breadcrumbs items={breadcrumbItems} />
      </BreadcrumbsContainer>
      <Article
        backButtonLink={`/international/${country}`}
        content={content}
        destinationName={title}
        relatedArticles={relatedDestinations.concat(relatedArticles)}
        affiliateData={{
          previewImageUrl: imageUrl ?? '',
          klookUrl,
          getYourGuideUrl,
          titleNameOverride,
        }}
      />
    </>
  );
};

export default DestinationNavigationWrapper;
